import React,{useEffect,useState} from 'react';
import { NavLink } from 'react-router-dom';

import './styles/App.css';
import classes from './components/ServiceAll/ServiceAll.module.css';
import jangba from './img/jangba.png';
import TopTitle from './Pc_TopTitle';
import queryString from 'query-string'
import more from './img/more.png';
import {comma,uncomma,instance} from './common';

function CheckCart({u_id,cartData,setCartData,cartLength,setCartLength}){
  
  let obj = {
    u_id:u_id,
  }

  useEffect(() => {
    const fetchData = async () => {
      instance.post('/cart/my_cart',obj).then(function(res){
          setCartLength(res.data.length);
          setCartData(res.data);
        });
    
    };

    fetchData();

  }, []);

  const count = {
    position: 'absolute',
    top: 0,
    right: '-3px',
    color: '#fff',
    background: 'red',
    width: '16px',
    textAlign: 'center',
    fontSize: '11px',
    borderRadius: '90px'
  }

  return (
      <>
      {
        cartLength > 0
        ?<span style={count}>{cartLength}</span>
        :<span></span>
      }  
      </>  
      
  );
}

function ServiceAll({location,history}) {
  // user logged in or anonymous
  let res = window.sessionStorage.result || JSON.stringify({
    u_type: 'anonymous',
    u_id: -1
   });
  let session = JSON.parse(res);
  let {u_type,u_id} = session;

  // 새로고침하면 url에 한글폰트가 깨지므로 영문으로 변경
  // 예시: ?cate=%EC%8D%AC%EA%B0%80%EB%93%9C%ED%95%98%EC%9D%B4%ED%8D%BC%EC%9D%B4%EB%B2%A4%ED%8A%B8
  const query = queryString.parse(location.search);
  let cate = (query.cate === 'sungard') ? '썬가드하이퍼이벤트' : ( (query.cate === 'hyundai') ? '현대캐피탈서비스' : 'BtoB' );
  
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const page = 1;
  const [ppp, setPpp] = useState(10);
  const [cartLength, setCartLength] = useState(0);
  const [cartData, setCartData] = useState([]);
  const [category, setCategory] = useState('');

  useEffect(() => {
    let obj = {
      s_cate:cate,
      page:page,
      ppp:ppp
    }
    instance.post('/service/cate',obj).then(function(res){
          setData(res.data.rows);
          setTotal(res.data.totalCount);
      });
  }, [ppp, category]);

    const moreInfo = () => {
      setPpp(ppp+4);
    }


    const goService = (e) => {
      const {id} = e.target.dataset;
      console.log('id : ',id);
      if(query.r_id){
        history.push('/service?s_id='+id+'&r_id='+query.r_id);
      }else{
        history.push('/service?s_id='+id);
      }
      
    }

    // console.log('data : ', data)

    const onClickCart = () => {
      if (u_id === -1) {
        alert('로그인이 필요합니다');
      }
      else if(query.r_id){
        history.push('/cart?r_id='+query.r_id);
      }else{
        history.push('/cart');
      }
      
      
    }

    const activateTab = (queryStr) => {
      return (location.search === `?cate=${queryStr}`) ? true : false;
    }
    const activeStyle = {
      background: '#2F79D9',
      color: '#fff',
      border: '0'
    }

  return (
    <>
     <TopTitle style={{marginTop:'60px'}}  title="서비스 신청"/>   
      <div className="container mb-5" style={{paddingRight:"100px", paddingLeft:"100px"}}>
        <div style={{marginBottom:'87px'}} className="row col-12 pl-3 pr-3">
            <NavLink onClick={() => setCategory('썬가드하이퍼이벤트')} className={`col-4 ${classes.categoryLink}`} activeStyle={activeStyle} isActive={() => activateTab('sungard')} to='/serviceall?cate=sungard'>썬가드 하이퍼 이벤트</NavLink>
            <NavLink onClick={() => setCategory('현대캐피탈서비스')} className={`col-4 ${classes.categoryLink}`} activeStyle={activeStyle} isActive={() => activateTab('hyundai')} to='/serviceall?cate=hyundai'>현대캐피탈 신차할부 신차패키지 서비스</NavLink>
            <NavLink onClick={() => setCategory('BtoB')} className={`col-4 ${classes.categoryLink}`} activeStyle={activeStyle} isActive={() => activateTab('BtoB')} to='/serviceall?cate=BtoB'>SC글로벌 B to B</NavLink>
        </div>
          {(u_type === '카마스터' || u_type === '일반고객') && <span className="mb-3 jangBaimg"  onClick={onClickCart}>
            <CheckCart 
            u_id={u_id} 
            cartData={cartData} 
            setCartData={setCartData}
            cartLength={cartLength}
            setCartLength={setCartLength}
            />
            <img src={jangba} style={{width:'100px',verticalAlign:'bottom', cursor:'pointer'}}/>
          </span>}
          <div className="row p-0">
            {
              data.map(v =><div className="col-4 pt-4 pb-3" key={v.s_id} data-id={v.s_id}>
              <div className="" data-id={v.s_id}>
                <div className="col-12 px-0"  data-id={v.s_id} ><img className="w-100" src={v.s_img} /></div><div  data-id={v.s_id}  className=" d-inline-block"  style={{ wordBreak:'keep-all',verticalAlign:'top'}}>
                  <h4 onClick={goService} className={classes.itemTitle}  data-id={v.s_id}>{v.s_name}</h4>
                  <div  data-id={v.s_id} style={{marginTop:'30px'}}>
                    {
                      query.cate === 'sungard'
                      ?
                      <>
                        <h5  data-id={v.s_id} style={{textDecoration: 'line-through', fontWeight:"100", fontSize:"14px", color:"#999999"}}>소비자가 : {comma(v.s_price)}원</h5>
                        <h4  data-id={v.s_id} className="font-weight-bold specialHal" style={{fontSize:"22px"}}>특별 할인가 : {comma(v.s_member_price)}</h4>
                      </>
                      :
                      u_type === '카마스터'
                      ?
                      <>
                        <h5  data-id={v.s_id} style={{textDecoration: 'line-through', fontWeight:"100", fontSize:"14px", color:"#999999"}}>소비자가 : {comma(v.s_price)}원</h5>
                        <h4  data-id={v.s_id} className="font-weight-bold specialHal" style={{fontSize:"22px"}}>특별 할인가 : {comma(v.s_member_price)}</h4>
                      </>
                      :
                      <h4  data-id={v.s_id} className="font-weight-bold specialHal" style={{fontSize:"22px"}}>소비자가 : {comma(v.s_price)}</h4>
                    }
                    
                  </div>
                </div>
              </div>
          </div>)
            }
              
          </div>
          <div className="text-center mt-3">
            {
              total != data.length && <img style={{ width:'35px' }} src={more} onClick={moreInfo}/>
            }
            
          </div>
      </div>
    </>
  );
}

export default ServiceAll;